export default __webpack_public_path__ + "static/media/1-Cloudxier-AdventureIndonesia.c4494fe7.jpg";